import { render, staticRenderFns } from "./setting-advanced-tag.vue?vue&type=template&id=0e525124&"
import script from "./setting-advanced-tag.vue?vue&type=script&lang=js&"
export * from "./setting-advanced-tag.vue?vue&type=script&lang=js&"
import style0 from "./setting-advanced-tag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports